export enum CreateNewReportSteps {
    Type,
    Parameters,
    ViewReport
}
